"use client";

import { EdgenModalCreateAble } from "@components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@components/EdgenModal/waitForEdgenModalRoot";

import { AddAccountModalContent } from "./AddAccountModalContent";
import { addAccountModalShellProps } from "./addAccountModalShell";
import type { PlaidImportModalResult } from "@components/PlaidImportModal/types";

let pendingAddAccountModal: Promise<PlaidImportModalResult> | null = null;

export interface OpenAddAccountModalParams {
  /** "Connect with Plaid" — opens Plaid import (forceFreshConnect). */
  onConnect?: () => void;
  /** "Send Ed a screenshot" — opens responsive chat. */
  onUpload?: () => void;
}

/**
 * Add Account drawer — H5 bottom sheet / PC centered modal.
 * Scrim / swipe-down / ✕ close = linear termination (no callback fired).
 */
export const openAddAccountModal = (
  params: OpenAddAccountModalParams = {},
): Promise<PlaidImportModalResult> => {
  if (pendingAddAccountModal) {
    return pendingAddAccountModal;
  }

  const { onConnect, onUpload } = params;

  pendingAddAccountModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<PlaidImportModalResult>((resolve) => {
        let settled = false;
        let modalCall: Promise<boolean> | null = null;

        const finish = (result: PlaidImportModalResult) => {
          if (settled) {
            return;
          }
          settled = true;
          pendingAddAccountModal = null;
          if (modalCall) {
            EdgenModalCreateAble.end(modalCall, false);
          } else {
            EdgenModalCreateAble.end(false);
          }
          resolve(result);
        };

        modalCall = EdgenModalCreateAble.call({
          children: (
            <AddAccountModalContent
              onConnect={() => onConnect?.()}
              onUpload={() => onUpload?.()}
              onClose={finish}
            />
          ),
          ...addAccountModalShellProps(),
          onDismiss: () => finish({ action: "close" }),
        });
      }),
  ).catch((error) => {
    pendingAddAccountModal = null;
    throw error;
  });

  return pendingAddAccountModal;
};
